import { ChallengesTable } from 'domain/feature/hub/dashboard/ChallengesTable'
import { DashboardEvaluatorsList } from 'domain/feature/hub/dashboard/evaluators'
import { DashboardGeneralStatsList } from 'domain/feature/hub/dashboard/generalStats'
import { PageTitle } from 'domain/feature/hub/pageTitle/styles'
import { Row } from 'react-bootstrap'
import { trans } from 'sharedKernel/i18n'
import { loggedUser } from 'sharedKernel/user/LoggedUser'
import { DashboardWrapper } from './style'
import React, { useEffect } from "react";
import { useSmartNavigateLegacy as useNavigate } from "components/SmartLink";
import { HubCompanyDashboardSolutionsNiche } from "../../../../domain/feature/hub/dashboard/charts/SolutionsArea";
import { HubCompanyDashboardSolutionsCity } from "../../../../domain/feature/hub/dashboard/charts/SolutionsCity";
import "./styles.css";
import { getProvider } from "sharedKernel/api/hooks/mutation";
import { ROUTES } from "sharedKernel/constants";
import { getHubRoute } from "sharedKernel/handlers/routes";
import { cookies } from 'sharedKernel/cookies/behavior'
import { getCredLocalStorage } from "sharedKernel/auth/credLocalStorage";

export const HubDashboardPage = (): JSX.Element => {
  const user = loggedUser.get();
  const navigate = useNavigate();

  useEffect(() => {
    const companyType = getCredLocalStorage()?.company?.type;
    const isAdminCityHall = companyType?.type === "Admin City Hall";

    const userCookie = cookies.get('_perm');
    let hasAdminCityHallFeature = false;
    if (userCookie?.features) {
      hasAdminCityHallFeature = userCookie.features.some(
        (feature: any) => feature.code === 'admin city hall' || feature.code === 'admin_city_hall'
      );
    }

    if (isAdminCityHall || hasAdminCityHallFeature) {
      navigate(getHubRoute(ROUTES.HUB.STARTUP.CHALLENGE_LIST), { replace: true });
    }
  }, [navigate]);

  const labels = {
    title: trans("Bem-vindo(a), "),
  };

  return (
    <DashboardWrapper>
      <PageTitle>
        {labels.title + (user.cityHallInfo?.Name || user.name)}
      </PageTitle>

      {user.company?.powerBiUrl ? (
        <Row as="section">
          <div className="powerbi-wrapper">
            <iframe
              title="bi_teia"
              width="600"
              height="800"
              src={user.company.powerBiUrl}
              allow="fullscreen"
              style={{ border: "none" }}
            ></iframe>
          </div>
        </Row>
      ) : (
        <>
          <DashboardGeneralStatsList />
          <Row className="pb-md-1" as="section">
            <ChallengesTable />
            <DashboardEvaluatorsList />
          </Row>
        </>
      )}
    </DashboardWrapper>
  );
};
